/* eslint-disable no-undef */
const newsAPIKey = 'f3af7271688e45d68dd33baf9e56ab51';

function getRandOutlet() {
  const outlets = [
    'the-new-york-times',
    'business-insider',
    'espn',
    'mashable',
    'techcrunch',
    'the-huffington-post',
    'the-next-web',
    'the-verge',
    'the-washington-post',
    'time',
    'bbc-news',
    'ars-technica',
  ];

  return outlets[Math.floor(Math.random() * outlets.length)];
}

function getNews(callback) {
  const outlet = getRandOutlet();
  return fetch(`https://newsapi.org/v1/articles?source=${outlet}&&apiKey=${newsAPIKey}`, {
    accept: 'application/json',
  }).then(checkStatus)
    .then(parseJSON)
    .then(callback);
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    const error = new Error(`HTTP Error ${response.statusText}`);
    error.status = response.statusText;
    error.response = response;
    console.log(error); // eslint-disable-line no-console
    throw error;
  }
}

function parseJSON(response) {
  return response.json();
}

const NewsAPI = {
  getNews
};
export default NewsAPI;



// WEBPACK FOOTER //
// ./src/api/NewsAPI.js